export default "__VITE_PUBLIC_ASSET__f3bfb4cd__"